export default __webpack_public_path__ + "static/media/BoxBtnTextHuman.2984b3fa.png";